module.exports = __webpack_public_path__ + "img/shadow-cochl@2x.09d35ee1.png";